<div class="flex row w-100 card g-44">
	<app-image [src]="thumbnailSrc" placeholder="assets/images/video-upload-category-placeholder.png" width="345px" height="195px" [fitCover]="true"></app-image>
	<div class="flex column g-20">
		<div class="flex column g-8">
			<h5 class="m-0">{{ 'category-creation.promotional_video_title' | translateWithKeys }}</h5>
			<p class="body2">{{ 'category-creation.promotional_video_description' | translateWithKeys }}</p>
		</div>
		@if (uploaderListener) {
			<div class="uploader-container" [ngClass]="{ 'error-border': externalErrorMessage }">
				@if (externalErrorMessage) {
					<div class="flex row g-8">
						<mat-icon svgIcon="info_error" color="warn"></mat-icon>
						<span>{{ externalErrorMessage | translateWithKeys }}</span>
					</div>
					<mat-icon svgIcon="close_black" (click)="clearError()" class="pointer"></mat-icon>
				} @else {
					<div class="flex row space-between vertical-center w-100 g-8">
						<div class="flex row w-100 vertical-center g-8">
							<mat-progress-bar mode="determinate" [value]="uploaderListener | async"></mat-progress-bar>
							<span class="progress-number">{{ uploaderListener | async }}%</span>
						</div>
						<mat-icon svgIcon="close_black" (click)="cancel(videoInput)" class="pointer"></mat-icon>
					</div>
				}
			</div>
		} @else {
			@if (thumbnailSrc) {
				<div class="flex row g-20">
					<button class="view-btn btn-border border-accent" mat-flat-button (click)="removeVideo(videoInput)">{{'general.remove' | translateWithKeys}}</button>
					<button class="view-btn bg-primary-darker text-accent-lighter" mat-flat-button (click)="videoInput.value = null; videoInput.click()">{{'general.replace' | translateWithKeys}}</button>
				</div>
			} @else {
				<button class="view-btn btn-border border-accent" mat-button (click)="videoInput.click()"><mat-icon class="icon" svgIcon="upload_outlined_black"></mat-icon>{{'general.upload' | translateWithKeys}}</button>
			}
			@if (error) {
				<div class="flex row">
					<mat-icon color="warn" class="warning" svgIcon="warning"></mat-icon>
					<span class="text-warn">{{ 'category-creation.promotional_video_size_exceeded' | translateWithKeys:{ params: { limit: (videoMaxSizeInBytes | fileSize) } } }}</span>
				</div>
			}
			@if (showError) {
				<div class="container-error bg-warn-lighter m-0">
					<mat-icon color="warn" svgIcon="warning"></mat-icon><span class="text-warn">{{'category-creation.promotional_video_required' | translateWithKeys}}</span>
				</div>
			}
		}
	</div>
</div>
<input #videoInput type="file" hidden (change)="onVideoSelected($event)" accept="video/mp4" [multiple]="false">
